import { render, staticRenderFns } from "./EventfyLoader.vue?vue&type=template&id=1f2b80d6&scoped=true&"
import script from "./EventfyLoader.vue?vue&type=script&lang=js&"
export * from "./EventfyLoader.vue?vue&type=script&lang=js&"
import style0 from "./EventfyLoader.vue?vue&type=style&index=0&id=1f2b80d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b80d6",
  null
  
)

export default component.exports